import {
  dragLayer,
  lineLayer,
  mainLayer
} from "../../pixi-components/mainContainer/mainContainer";
import { spatialRegistry } from "../interactionEngine/spatialRegistry";
import { cleanUpRootNodeBounds } from "../interactionEngine/worldBoundary";
import { lineUnrender } from "./lineRenderer";
import { mainUnrender } from "./renderer";

export const cleanup = () => {
  mainLayer.removeChildren();
  dragLayer.removeChildren();
  lineLayer.removeChildren();
  lineUnrender();
  mainUnrender();
  cleanUpRootNodeBounds();
  spatialRegistry.reset();
};
